import * as React from 'react';

export const PortfolioAgreementDisclaimerContext = React.createContext<boolean>(false);
